// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"51c857cf","879":"5b2b8c5c"}[chunkId] + ".chunk.js";
};